/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Document_WaybillInputs */

const en_inbound_document_waybill = /** @type {(inputs: Inbound_Document_WaybillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waybill`)
};

/**
* | output |
* | --- |
* | "Waybill" |
*
* @param {Inbound_Document_WaybillInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_document_waybill = /** @type {((inputs?: Inbound_Document_WaybillInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Document_WaybillInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_document_waybill(inputs)
});